export default __webpack_public_path__ + "static/media/waitingAudio.667b2ba5.mp3";